import { useCart } from '../../context/CartContext'
import data from '../../data.json'
import { formatCurrency } from '../../utility/formatCurrency';
import './CartItem.css'

type CartItemProps = {
  id: number,
  quantity: number

}
const CartItem = ({ id, quantity }: CartItemProps) => {
  const { removeFromCart } = useCart();
  const item = data.find(item => item.id === id)
  if (item == null) return null
  
  return (
    <div>
      <img className='CartImage' src={item.image} alt={item.name} />
      <h3 className='CartItemTitle'>{item.name}</h3>
      <button onClick={() => removeFromCart(id)}>Remove</button>
      <p className='Currency'>{formatCurrency(item.price)}</p>
      

    </div>
  )
}

export default CartItem